class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.positionDropdown = this.positionDropdown.bind(this);
  }

  onToggle() {
    super.onToggle();

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') === '') {
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }

    if (this.mainDetailsToggle.open) {
      this.positionDropdown();
      window.addEventListener('resize', this.positionDropdown);
      window.visualViewport?.addEventListener('resize', this.positionDropdown);
      return;
    }

    window.removeEventListener('resize', this.positionDropdown);
    window.visualViewport?.removeEventListener('resize', this.positionDropdown);
    this.content?.style.removeProperty('left');
  }

  positionDropdown() {
    if (!this.mainDetailsToggle.open || !this.content) return;

    const isSupportedMenu =
      this.content.classList.contains('list-menu--disclosure') || this.content.classList.contains('mega-menu__content');

    if (!isSupportedMenu) return;

    const viewportPadding = 16;
    this.content.style.left = '0px';

    const contentRect = this.content.getBoundingClientRect();
    let offset = 0;

    if (contentRect.right > window.innerWidth - viewportPadding) {
      offset -= contentRect.right - (window.innerWidth - viewportPadding);
    }

    if (contentRect.left + offset < viewportPadding) {
      offset += viewportPadding - (contentRect.left + offset);
    }

    this.content.style.left = `${offset}px`;
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.positionDropdown);
    window.visualViewport?.removeEventListener('resize', this.positionDropdown);
  }
}

customElements.define('header-menu', HeaderMenu);
